export default __webpack_public_path__ + "slices/main/assets/public/media/camper-underlines/underline--white.cd781ca1cae297fdb523998a41d8ad3c.svg";